import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=d1ee2774&scoped=true&"
import script from "./wrap.vue?vue&type=script&lang=js&"
export * from "./wrap.vue?vue&type=script&lang=js&"
import style0 from "./wrap.vue?vue&type=style&index=0&id=d1ee2774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ee2774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1ee2774')) {
      api.createRecord('d1ee2774', component.options)
    } else {
      api.reload('d1ee2774', component.options)
    }
    module.hot.accept("./wrap.vue?vue&type=template&id=d1ee2774&scoped=true&", function () {
      api.rerender('d1ee2774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/wrap.vue"
export default component.exports